export default function Section15() {
    const industries = [
        {
            title: "Retail & Fashion",
            text: "Retail ecommerce website development that increases sales",
            icon: "🛍️",
        },
        {
            title: "Tech Startups",
            text: "Scalable websites and apps that support rapid growth",
            icon: "🧠",
        },
        {
            title: "Healthcare",
            text: "Healthcare website development with secure and compliant solutions",
            icon: "🏥",
        },
        {
            title: "Real Estate & Enterprises",
            text: "Real estate web portals to connect buyers, sellers, and agents",
            icon: "🏢",
        },
        {
            title: "SaaS & Digital Platforms",
            text: "SaaS website development for scalable growth",
            icon: "📱",
        },
    ];

    return (
        <div className="Section15 my-[-20px] md:my-[10px] md:py-[0px] bg-gray-100">
            {/* Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Website Development <span className="text-[#DA2128]">Industries We Serve</span>
                </h2>
                <h3 className="mt-6 text-[#DA2128] text-[18px] md:text-[20px] font-semibold max-w-[600px] mx-auto">
                    Tailored Website Solutions for Every Industry.
                </h3>
                <p className="mt-2 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    Our team has a deep understanding of various industries, allowing us to provide specialized
                    solutions that address your unique challenges and objectives.
                </p>
            </div>

            {/* Industries Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
                {industries.map((industry, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300 p-6 rounded-2xl shadow-md bg-[#f5f5f5]"
                    >
                        {/* Icon */}
                        <div className="text-4xl md:text-5xl mb-4">{industry.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                            {industry.title}
                        </h3>

                        {/* Description */}
                        <p className="text-gray-600 text-sm md:text-base">{industry.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

